import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-d_you",
  "use": "icon-d_you-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 16\" id=\"icon-d_you\"><defs><style>#icon-d_you .a{fill:#fff;stroke:#707070;}#icon-d_you .b{clip-path:url(#icon-d_you_a);}#icon-d_you .c{fill:none;stroke:rgba(0,0,0,0.72);stroke-linecap:round;stroke-linejoin:round;}</style><clipPath id=\"icon-d_you_a\"><rect class=\"a\" width=\"12\" height=\"16\" /></clipPath></defs><g class=\"b\"><path class=\"c\" d=\"M3.407,2458l6,6-6,6\" transform=\"translate(-0.407 -2455.496)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol